import { Button, Headline, Spacing, Text } from '@vkontakte/vkui';
import plusImage from 'img/quota-landing/family/spaceToEach/tooltipImage.png';
import React, { type ReactEventHandler, type RefObject, forwardRef, useCallback } from 'react';
import { isRebrandingQuotaLanding } from 'reactApp/appHelpers/featuresHelpers';
import { FloatingTooltip } from 'reactApp/ui/FloatingTooltip/FloatingTooltip';
import { ETooltipAppearance, ETooltipPlacement, ETooltipSize } from 'reactApp/ui/FloatingTooltip/FloatingTooltip.types';
import { sendDwh } from 'reactApp/utils/ga';

import styles from './FamilySpaceToEachTooltip.css';

interface FamilySpaceToEachTooltipProps {
    setShowTooltip: React.Dispatch<React.SetStateAction<boolean>>;
    onButtonClick: ReactEventHandler;
}

export const FamilySpaceToEachTooltip = forwardRef<HTMLDivElement, FamilySpaceToEachTooltipProps>(
    ({ setShowTooltip, onButtonClick }, ref) => {
        const onShow = useCallback(() => {
            sendDwh({
                eventCategory: 'tooltip',
                action: 'show',
                dwhData: {
                    name: 'mnzfam_separate_quota',
                },
                dwh_enabled: true,
            });
        }, []);

        const onClose = useCallback(() => {
            sendDwh({
                eventCategory: 'tooltip',
                action: 'close',
                dwhData: {
                    name: 'mnzfam_separate_quota',
                },
                dwh_enabled: true,
            });

            if (setShowTooltip) {
                setShowTooltip(false);
            }
        }, [setShowTooltip]);

        const onBuyClick = useCallback(
            (event) => {
                sendDwh({
                    eventCategory: 'tooltip',
                    action: 'click',
                    dwhData: {
                        name: 'mnzfam_separate_quota',
                    },
                    dwh_enabled: true,
                });
                if (setShowTooltip) {
                    setShowTooltip(false);
                }
                onButtonClick(event);
            },
            [onButtonClick, setShowTooltip]
        );

        return (
            <FloatingTooltip
                target={ref as RefObject<HTMLDivElement>}
                appearance={ETooltipAppearance.dark}
                placement={ETooltipPlacement.top}
                allowFlip={false}
                size={ETooltipSize.fit}
                qaId="family-space-to-each-tooltip"
                usePortal
                belowSticky
                isRebrandingQuotaLanding={isRebrandingQuotaLanding}
                leftOffset={16}
                closeOnOutsideClick
                onClose={onClose}
                onShow={onShow}
                className={styles.familySpaceToEachWrapper}
            >
                <div className={styles.root}>
                    <Headline weight="2" className={styles.title}>
                        Чем больше людей в подписке,{'\n'}тем больше Облако
                    </Headline>
                    <Spacing size={6} />
                    <Text className={styles.text}>У каждого свои ГБ — но платить{'\n'}за них дополнительно не надо</Text>
                    <Spacing size={10} />
                    <Button size="m" mode="secondary" className={styles.button} onClick={onBuyClick}>
                        Подключить
                    </Button>
                    <img src={plusImage} alt="Место каждому" className={styles.image} />
                </div>
            </FloatingTooltip>
        );
    }
);

FamilySpaceToEachTooltip.displayName = 'FamilySpaceToEachTooltip';
